export default __webpack_public_path__ + "static/media/undraw_teamwork_hpdk.b91a392b.svg";